export class Votar_B{
    constructor(
        public _id: string,
        public valor: Number,
        public tipo: string
    ){}
}